export const convertMinutesToTime = (totalMinutes = 0) => {
  const roundedMinutes = Math.round(totalMinutes * 10000) / 10000;
  const totalSeconds = roundedMinutes * 60;
  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
  const seconds = Math.round(totalSeconds % 60);
  return { days, hours, minutes, seconds };
};

export const convertTimeToMinutes = ({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
}) => {
  const totalSeconds =
    days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds;
  return Math.round((totalSeconds / 60) * 10000) / 10000;
};

export const formatTime = (totalMinutes = 0) => {
  if (!totalMinutes) return "";
  const { minutes, seconds } = convertMinutesToTime(totalMinutes);
  
  const parts = [];
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0) parts.push(`${seconds}s`);
  
  return parts.join(" ") || "0s";
};

export const timeConfig = {
  days: { min: 0, max: 99, label: "days", shortLabel: "d" },
  hours: { min: 0, max: 23, label: "hours", shortLabel: "h" },
  minutes: { min: 0, max: 59, label: "mins", shortLabel: "m" },
  seconds: { min: 0, max: 59, label: "sec", shortLabel: "s" },
};
